import { aggregatesSummaryModel } from '@models/Filing/aggregatesSummary';

export const aggregatesSummaryModelItaly = (
  aggregates = { summaryTabs: [] },
  countryIso,
  filingPeriodId
) =>
  aggregates?.summaryTabs.reduce(
    (accumulator, currentValue) => [
      ...accumulator,
      {
        ...aggregatesSummaryModel(currentValue, countryIso, filingPeriodId),
        validForUse: currentValue?.validForUse,
        tabTitle: currentValue?.tabTitle,
        isDataProcessingAggregate: undefined,
      },
    ],
    []
  );
